module.exports = __webpack_public_path__ + "img/2.85a2fe6c.jpg";